import { Link } from 'react-router-dom';
import useCustomer from 'hooks/useCustomer';
import ConnectorManagementCustomerPage from 'shiplab-components/ConnectorManagementCustomerPage';
import StepProgress from 'shiplab-components/StepProgress';
import React, { useEffect, useState } from 'react';
import { useLoading } from 'providers/LoadingProvider';
import { useAuth } from 'hooks/useAuth';
import { BillingInfo } from 'models/Billing';
import { getBilling } from 'services/billingService';
import { isHomepageTrialCtaEligible } from 'utils/billing';

interface ConnectorStatusKpi {
  passed: string;
  failed: string;
  unprocessed: string;
}

const Home = () => {
  const { weeklySummary, monthlySummary, connectorStatusKpi, profile, connectors } =
    useCustomer();
  const { accessToken } = useAuth();
  const { showLoading, hideLoading } = useLoading();
  const [billing, setBilling] = useState<BillingInfo | null>(null);
  const [billingLoaded, setBillingLoaded] = useState(false);

  useEffect(() => {
    showLoading(); // شروع لودینگ
    const timeout = setTimeout(() => {
      hideLoading(); // اتمام لودینگ
    }, 2000);

    return () => clearTimeout(timeout);
  }, []);

  useEffect(() => {
    if (!accessToken) {
      setBilling(null);
      setBillingLoaded(false);
      return;
    }
    let cancelled = false;
    setBillingLoaded(false);
    void getBilling(accessToken)
      .then(data => {
        if (!cancelled) {
          setBilling(data);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setBilling(null);
        }
      })
      .finally(() => {
        if (!cancelled) {
          setBillingLoaded(true);
        }
      });
    return () => {
      cancelled = true;
    };
  }, [accessToken]);

  // تبدیل آرایه به شیء  
  const kpiData: ConnectorStatusKpi = Array.isArray(connectorStatusKpi)
    ? connectorStatusKpi[0]
    : connectorStatusKpi;

  const { passed, failed, unprocessed } = kpiData || {
    passed: '0',
    failed: '0',
    unprocessed: '0'
  };

  const customerName = profile?.display_name || 'there';
  const customerInitial = customerName?.[0]?.toUpperCase() || '•';
  const enabledConnectors = (connectors || []).filter(connector => connector.enabled);
  const enabledConnectorCount = enabledConnectors.length;
  const issueCount = enabledConnectors.filter(connector => {
    const status = connector?.status?.toString().trim().toUpperCase();
    return status === 'ERROR';
  }).length;
  const showTrialCta = billing ? isHomepageTrialCtaEligible(billing) : false;

  return (
    <>
      <div className="pb-5">
        {/* {showTrialCta && (
          <div className="bg-soft-primary border border-primary-200 rounded-3 px-4 py-3 mb-3">
            <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-3">
              <div>
                <h4 className="mb-1">Activate your Shiplab trial</h4>
                <p className="mb-0 text-700">
                  Choose a plan to start your 30-day trial. No charge today; card
                  required.
                </p>
              </div>
              <Link
                to="/pages/plans-billing"
                className="btn btn-primary text-nowrap"
              >
                View plans
              </Link>
            </div>
          </div>
        )} */}
        <div className="bg-white border rounded-3 px-4 py-3">
          <div className="d-flex align-items-start gap-3">
            <div className="flex-grow-1">
              <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-3">
                <h2 className="mb-0">Welcome back, {customerName}</h2>
                <div className="d-flex flex-row align-items-center gap-3">
                  <Link to="/explore" className="btn btn-primary px-4">
                    Explore Data
                  </Link>
                  {/* <Link
                    to="/connector-management"
                    className="btn btn-link p-0 text-decoration-none"
                  >
                    Manage connectors →
                  </Link> */}
                </div>
              </div>
              <div className="text-muted mt-1">
                Your carrier data pipelines are active and running.
              </div>
              <div className="mt-3 bg-light border rounded-3 px-3 py-2">
                <div className="d-flex align-items-center text-muted mb-1">
                  <span
                    className="rounded-circle bg-success d-inline-block me-2"
                    style={{ width: 8, height: 8 }}
                  />
                    <span>{enabledConnectorCount} enabled connectors</span>
                </div>
                <div className="d-flex align-items-center text-muted">
                  <span
                    className={`rounded-circle d-inline-block me-2 ${issueCount > 0 ? 'bg-danger' : 'bg-success'}`}
                    style={{ width: 8, height: 8 }}
                  />
                  <span>{issueCount} issues detected</span>
                </div>
              </div>
              <div className="mt-3 text-muted small">
                Shiplab automatically collects raw carrier invoice data and delivers it to your
                systems — no portals, no scraping, no lock-in.
              </div>
            </div>
          </div>
        </div>
      </div>
      <ConnectorManagementCustomerPage />
      <StepProgress billing={billing} billingLoaded={billingLoaded} />
    </>
  );
};

export default Home;
